import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import cx from 'classnames';
import HeartIcon from 'components/icons/Heart';
import HeartFilled from 'components/icons/HeartFilled';
import useFavorites from 'utils/hooks/useFavorites';
import { hasPrice } from 'utils/parsePrice';

import { colors } from 'utils/tailwindColors';

const Container = styled.div`
  width: 21rem;
  height: 10rem;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0);
  transition: all 0.4s ease-out;
  z-index: 999;
  pointer-events: all;
`;

const IconContainer = styled.div`
  width: 1.75rem;
  height: 1.75rem;
`;

const Content = styled.div`
  transition: all 0.4s ease-out;
`;

const ImageContainer = styled.div`
  height: 10rem;
`;

const CardTitle = styled.div`
  letter-spacing: -0.029rem;
`;

const CardSubtitle = styled.div`
  letter-spacing: 0.007rem;
`;

const AvailableFlag = styled.div`
  border-radius: 0.813rem;
  width: fit-content;
  line-height: 0.5rem;
`;

const getCommunityStylesFormat = (communityStyles) => {
  const styles = communityStyles.split(',');
  if (styles && styles.length > 1) {
    let newFormat = styles.reduce(function (a, b) {
      return a.concat(', ' + b);
    });
    return newFormat;
  }

  return communityStyles;
};

const MapSearchCardMobile = ({ card = {}, ...rest }) => {
  const favoritesList = rest.favoritesList;
  const { saveFavorite, deleteFavorite } = useFavorites();

  const id = card.id;
  const statusShortDescription = card.statusShortDescription;
  const titleCard = card.title || '';
  const communityStyles = card.communityStyles;
  const homeType = card.homeType || '';
  const price = card.price;
  const hasDisplayPrice = price && hasPrice(price.price);
  const isFavorite = favoritesList.includes(id);

  const handleFavoriteClick = (id) => {
    if (!isFavorite) {
      saveFavorite(id);
    } else {
      deleteFavorite(id);
    }
  };
  if (!card.image) return null;

  return (
    <Container
      className={
        'relative w-full justify-between overflow-hidden rounded transform'
      }
      id={'InfoWindow-' + id}
    >
      <Content className='bg-white flex flex-row '>
        <ImageContainer className='w-4/12 h-full text-center relative  overflow-hidden '>
          <a
            href={card.url}
            className=' h-full w-full '
            aria-label={'View ' + titleCard + ' information'}
          >
            <img
              className='object-cover h-full w-full '
              src={card.image.src}
              alt={card.image.alt}
            />
          </a>
        </ImageContainer>
        <div className='w-8/12 mx-2 my-2 flex flex-col items-left text-left'>
          <IconContainer
            className='flex items-center absolute top-0 right-0 justify-center
                rounded-full bg-white text-action-blue mt-1 mr-2 '
            onClick={() => handleFavoriteClick(id)}
            role='button'
            aria-label={isFavorite ? 'Mark as unfavorite' : 'Mark as favorite'}
            aria-pressed={isFavorite ? 'true' : 'false'}
          >
            {isFavorite ? (
              <HeartFilled className='h-5 w-5' />
            ) : (
              <HeartIcon className='h-5 w-5' />
            )}
          </IconContainer>
          <a href={card.url} aria-label={'View ' + titleCard + ' information'}>
            {statusShortDescription && (
              <AvailableFlag
                className='flex items-center justify-center
                  px-6 py-1 md:py-1 bg-white text-mattamy-blue-light
                border-2 border-mattamy-blue-light'
              >
                <p className='text-center font-trade-gothic-20 uppercase text-xs tracking-wide mt-1 md:leading-3'>
                  {statusShortDescription}
                </p>
              </AvailableFlag>
            )}

            <CardTitle className='font-trade-gothic-20 text-mattamy-blue text-xl whitespace-nowrap mt-2'>
              {titleCard}
            </CardTitle>

            {communityStyles ? (
              <p className='text-mattamy-gray-font text-sm font-trade-gothic-20 text-left font-bold mt-1'>
                {getCommunityStylesFormat(communityStyles)}
              </p>
            ) : (
              <div className='h-4'></div>
            )}

            <span className='font-graphie text-action-blue text-xs mt-1'>
              {homeType}
            </span>

            {price && (hasDisplayPrice || price.noPriceText) && (
              <div className='block flex items-baseline mt-1'>
                {hasDisplayPrice ? (
                  <>
                    <CardSubtitle className='font-graphie text-mattamy-blue-light text-xs leading-7'>
                      {price.normalText}
                    </CardSubtitle>
                    <CardTitle className='font-trade-gothic-20 text-mattamy-blue text-xl leading-9 ml-3 '>
                      {price.price}
                    </CardTitle>
                  </>
                ) : (
                  <CardTitle className='font-trade-gothic-20 text-mattamy-blue text-xl leading-9  ml-0'>
                    {price.noPriceText}
                  </CardTitle>
                )}
              </div>
            )}
          </a>
        </div>
      </Content>
    </Container>
  );
};

MapSearchCardMobile.propTypes = {
  card: PropTypes.object,
};

export default MapSearchCardMobile;
